<adl-table
  (configChange)="setConfig($event)"
  (checkboxChange)="onCheckboxChange($event)"
  (rowClick)="onPersonRouteTo($event)"
  (buttonClick)="onTableButtonClick($event)"
  [loading]="isLoading"
  [tableData]="measurementasHistory"
  [columnHeader]="columnHeader"
  [paginationInfo]="measurementasHistoryPaginated"
  [tableTitle]="'measurements' | transloco"
>
</adl-table>

<div class="container-fluid pb-3 gap-3 d-flex">
  <button class="btn btn-danger" [disabled]="!selectedItems.length" (click)="deleteSelected()">
    {{ 'delete_selected_measurements' | transloco }}
  </button>
  <button class="btn btn-primary" [disabled]="!selectedItems.length" (click)="download()">
    {{ 'download' | transloco }}
  </button>
</div>
<app-confirm-download-measurement-dialog (success)="resetSelectedRows()"></app-confirm-download-measurement-dialog>
<app-identify-measurement-dialog (identified)="getMeasurements(config)"></app-identify-measurement-dialog>
